import React from "react"
import { isImage, isDoc, isMedia, isSupportIframe, isAudio } from "./utils"
import DocViewer, { DocViewerRenderers } from "react-doc-viewer"
import { Image } from "antd";
import TagPill from "@components/TagPill";
import moment from "moment"

/** doc 预览区高度：drawer 内用视口比例；分栏 inline 用 flex 填满父级，避免再叠一层固定 vh */
const getViewElement = (url, docViewerHeight) => {
  if (!url) {
    return <div>Loading...</div>
  }
  if (isImage(url)) {
    return <Image rootClassName="previewImage" style={{ width: '100%', height: '100%' }} src={url} alt="errorimage" />
  }
  if (isDoc(url)) {
    return (
      <DocViewer
        pluginRenderers={DocViewerRenderers}
        style={{ width: '100%', height: docViewerHeight }}
        prefetchMethod="GET"
        documents={[{ uri: url, fileType: 'pptx' }]}
      />
    )
  }
  if (isMedia(url)) {
    return <video style={{ width: '100%', height: '100%' }} src={url} controls />
  }
  if (isSupportIframe(url)) {
    return <iframe style={{ width: '100%', height: '100%', border: 0 }} src={url} title="preview-file" />
  }
  if (isAudio(url)) {
    return <audio controls src={url} />
  }
  return <div style={{ width: '100%', height: '100%' }}>There is no preview.</div>
}

/**
 * @param {'inline'|'drawer'} variant — 同一时刻父组件应只挂载一处 FileViewer（inline 与 drawer 互斥）。
 */
export const FileViewer = ({ url = '', currentOpenFile, variant = 'drawer' }) => {
  const isFolder = currentOpenFile?.isFolder
  if (!currentOpenFile || isFolder) {
    return (
      <div style={{ textAlign: 'center', padding: '24px', color: '#888' }}>
        {isFolder ? 'Open a file to preview.' : 'Select a file to preview.'}
      </div>
    )
  }

  const outerStyle =
    variant === 'inline'
      ? {
          width: '100%',
          height: '100%',
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }
      : {
          width: '100%',
          height: '86vh',
          display: 'flex',
          flexDirection: 'column',
        }

  const docViewerHeight = variant === 'inline' ? '55vh' : '80vh'

  const modifiedLabel = currentOpenFile?.modified_date
    ? moment(currentOpenFile.modified_date).format('MM/DD/YYYY')
    : '—'

  return (
    <div style={outerStyle}>
      <div
        style={{
          textAlign: 'center',
          flex: 1,
          minHeight: 0,
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {getViewElement(url, docViewerHeight)}
      </div>
      <div style={{ textAlign: 'left', marginTop: 10, flexShrink: 0 }}>
        {Array.isArray(currentOpenFile.tags_list) && currentOpenFile.tags_list.length > 0 ? (
          <>
            Tags:
            <span style={{ marginLeft: 10 }}>
              {currentOpenFile.tags_list.map((item) => (
                <TagPill key={item} name={item} size="sm" />
              ))}
            </span>
          </>
        ) : null}
      </div>
      <div style={{ textAlign: 'left', marginTop: 10, flexShrink: 0 }}>
        ModifiedBy: {currentOpenFile.lastModified_name || '—'}
      </div>
      <div style={{ textAlign: 'left', marginTop: 10, flexShrink: 0 }}>
        ModifiedDate: {modifiedLabel}
      </div>
    </div>
  )
}
